import { Image } from '@packages/shared/src/ui/Image/Image';
import type { FC } from 'react';

export type CriteoBeaconImageProps = {
  /* image src */
  src: string;
  name?: string;
};

/**
 * CriteoBeaconImage component to render criteo beacon images
 * */
export const CriteoBeaconImage: FC<CriteoBeaconImageProps> = ({ src, name }) => (
  // NOTE if some sponsored cards will be hidden visually: convert to absolute positioned div with background-image, to allow for not loading the image when it is hidden, and not interrupt the parent layout flow; for now all sponsored cards are visible, so we can just use an image
  <Image
    aria-hidden
    src={src}
    width={1}
    height={1}
    alt={name ?? ''}
    className="absolute top-0 left-0 hidden size-[1px]"
    unoptimized
  />
);
